export default "__VITE_ASSET__2f7127b7__"